<template>
    <div class="air-container " :class="airShow ? 'air-container_active':''" id="airPanel">
        <div class="popup-air " :class="airShow ? 'popup-air_active':''">

            <div class="form-popup">
                <div class="img-flag-country flex-column jc-center ai-center">

                    <img :src="`/img/png100px/${this.$store.state.settings.country.code.toLowerCase()}.png`" alt="">

                    <p class="air-title flex jc-center">Your location is set to {{this.$store.state.settings.country[this.$store.state.settings.lang]}}</p>
                    <div class="air-currency flex-column jc-center ai-center">
                        <span>shop in {{ this.$store.state.settings.country.currency.code }} {{ this.$store.state.settings.country.currency.sign }}</span>

                    </div>
                    <button  class="air-btn" @click="getRedirect">continue</button>

                    <p class="air-country-region" @click="getCountry">Change country/region</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            airShow: true,
        }
    },
    name: "country-panel",
    methods:{
        getRedirect(){
            window.location.href = this.$store.state.settings.redirect;
        },
        getCountry(){
            this.airShow = false
            this.$parent.$refs.header.visible_country = true
        }

    }
}
</script>

<style scoped>

</style>
